"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefableMap = void 0;
exports.refableObject = refableObject;
exports.refableObjectValues = refableObjectValues;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
function refableObject(obj, refCtx, combine) {
    const m = new Map();
    const target = {};
    const returnObj = new Proxy(target, {
        get(_target, prop) {
            if (typeof prop !== 'string') {
                switch (prop) {
                    case Symbol.iterator:
                        return m.entries();
                }
                return m[prop];
            }
            if (prop === 'toJSON') {
                return () => {
                    const o = {};
                    m.forEach((v, k) => {
                        if (typeof o[k.valueOf()] !== 'undefined') {
                            o[k.valueOf()] = combine(k, o[k.valueOf()], v);
                        }
                        else {
                            o[k.valueOf()] = v;
                        }
                    });
                    return o;
                };
            }
            const propAsNetRef = refCtx.existingOrNewRef(prop);
            if (m.has(propAsNetRef)) {
                return m.get(propAsNetRef);
            }
            for (const [key, value] of m.entries()) {
                if (key.valueOf() === propAsNetRef.valueOf()) {
                    return value;
                }
            }
            return target[prop];
        },
        set(_target, prop, value) {
            if (typeof prop !== 'string' && !(prop instanceof sigma_engine_shared_1.NetRef)) {
                return false;
            }
            const propAsNetRef = (prop instanceof sigma_engine_shared_1.NetRef ?
                prop
                : refCtx.existingOrNewRef(prop));
            m.set(propAsNetRef, value);
            return true;
        },
        ownKeys() {
            return Array.from(new Set(Array.from(m.keys()).map((o) => o.valueOf())));
        },
        has(_target, prop) {
            if (prop === 'toJSON') {
                return true;
            }
            if (typeof prop === 'string' || prop instanceof sigma_engine_shared_1.NetRef) {
                const propAsNetRef = refCtx.existingOrNewRef(prop);
                if (m.has(propAsNetRef)) {
                    return m.get(propAsNetRef);
                }
                for (const [key, value] of m.entries()) {
                    if (key.valueOf() === propAsNetRef.valueOf()) {
                        return value;
                    }
                }
            }
            return m[prop];
        },
        getOwnPropertyDescriptor(_target, prop) {
            if (typeof prop !== 'string') {
                return undefined;
            }
            const propRef = refCtx.existingOrNewRef(prop);
            if (m.has(propRef)) {
                return {
                    value: m.get(propRef),
                    enumerable: true,
                    writable: true,
                    configurable: true,
                };
            }
            return Object.getOwnPropertyDescriptor(target, prop);
        },
        deleteProperty(_target, prop) {
            if (typeof prop !== 'string' && !(prop instanceof sigma_engine_shared_1.NetRef)) {
                return false;
            }
            const propRef = refCtx.existingOrNewRef(prop);
            if (m.has(propRef)) {
                m.delete(propRef);
                return true;
            }
            return false;
        },
    });
    for (const [key, value] of Object.entries(obj)) {
        returnObj[key] = value;
    }
    return returnObj;
}
function refableObjectValues(obj) {
    const entries = obj[Symbol.iterator];
    if (entries) {
        return Array.from(entries, ([, value]) => value);
    }
    return Object.values(obj);
}
class RefableMap extends Map {
    toJSON() {
        const obj = {};
        this.forEach((v, k) => {
            obj[k.valueOf()] = v;
        });
        return obj;
    }
}
exports.RefableMap = RefableMap;
//# sourceMappingURL=RefableNet.js.map